module.exports = __webpack_public_path__ + "img/mouse1.ab891aee.jpg";